import React from 'react'

const Logo = () => (
  <img src="/logos/logo_carolina_costa.png" width="250" height="82" alt="Carolina Costa"/>
)

export default Logo
